import { useState } from "react";
import { Link } from "react-router-dom";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase/config";
// import forgotimagelogo from "../../assets/images/gymfithorlogo2-removebg-preview.png";
import forgotimagelogo from "../../assets/images/gymfitorangelogo22.png";
import "./ForgotPassword.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");

  const handleResetPassword = async (e) => {
    e.preventDefault();

    try {
      await sendPasswordResetEmail(auth, email);

      alert("Password reset link has been sent to your email.");

      setEmail("");
    } catch (error) {
      console.error(error);

      alert("Failed to send reset email.");
    }
  };

  return (
    <div className="forgot-container">
      <div className="forgot-card">
        <div className="forgot-logo">
          <img src={forgotimagelogo} alt="logo" className="logocss" />
          <p className="logopara">Smart Gym & Fitness Management Software</p>
        </div>
        <div className="security-badge"> Secure Password Recovery</div>
        <h2>Forgot Password?</h2>

        <p>
          Enter your registered email address and we'll send you a password
          reset link.
        </p>

        <form onSubmit={handleResetPassword}>
          <input
            type="email"
            placeholder="Enter Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <button type="submit">Send Reset Link</button>
        </form>

        <div className="back-login">
          <Link to="/">← Back To Login</Link>
        </div>
      </div>
    </div>
  );
}
